$(document).ready(function() {
    var ajaxPath = '/action/customer-group';
    var ajaxPathForm = '/action/customer-group/form';
    var ajaxPathListItems = '/action/customer-group/list-items';

    var formWrapperId = 'customer_group_form_wrapper';
    var formWrapper = $('div#' + formWrapperId);

    var listWrapperId = 'customer_group_list_wrapper';
    var listWrapper = $('div#' + listWrapperId);

    var alertWrapperId = 'customer_group_alert_wrapper';

    var ajaxLockActive = false;

    // Hide or display the special vat select list
    $(document).on('click', 'div#' + formWrapperId + ' input[name="special_vat_checkbox"]', function () {
        var specialVatWrapper = $('div#special_vat_select_wrapper');
        if ($(this).is(':checked')) {
            specialVatWrapper.removeClass('hidden');
        } else {
            specialVatWrapper.addClass('hidden');
        }
    });

    // Hide or display the correct inputs when switching between automatic tas frequency
    $(document).on('click', 'div#' + formWrapperId + ' input[name="automatic_customer_card_value_task_active_checkbox"]', function () {
        let wrapper = $('div#autoamtic_customer_card_value_task_wrapper');
        if ($(this).is(':checked')) {
            wrapper.removeClass('hidden');
        } else {
            wrapper.addClass('hidden');
        }
    });

    // Hide or display the HTML for automatic edit of customer card task (cron)
    $(document).on('change', 'div#' + formWrapperId + ' select[name="automatic_customer_card_value_task_frequency"]', function () {
        console.log('test2');
        let frequency = $(this).val();
        let dateWrapper = $('div#' + formWrapperId + ' div#day_of_month_wrapper');
        let weekdayWrapper = $('div#' + formWrapperId + ' div#day_of_week_wrapper');
        if (frequency == 'each_month') {
            dateWrapper.removeClass('hidden');
            weekdayWrapper.addClass('hidden');
        } else {
            dateWrapper.addClass('hidden');
            weekdayWrapper.removeClass('hidden');
        }
    });

    // Get edit form for customer group
    $(document).on('click', 'div#' + listWrapperId + ' a.customer_group_list_item', function () {
        refreshForm($(this).attr('customer_group_id') * 1);
        return false;
    });

    // Save customer group
    $(document).on('click', 'div#' + formWrapperId + ' button#save_customer_group', function () {
        if (ajaxLockActive) {
            return false;
        }

        let name = $('div#' + formWrapperId + ' input[name="name"]').val();
        let groupNumber = $('div#' + formWrapperId + ' input[name="group_number"]').val();
        let specialVatCode = $('div#' + formWrapperId + ' select[name="vat_code"]').val();
        let customerGroupId = 0;
        let specialVatActivated = 0;
        let automaticCustomerCardValueTaskActive = 0;
        let editCustomerCardValuesTaskId = 0;
        let automaticCustomerCardValueTaskFrequency = '';
        let automaticCustomerCardValueTaskDayOfMonth = '';
        let automaticCustomerCardValueTaskDayOfWeek = '';
        let automaticCustomerCardValueTaskCronTime = '';
        let automaticCustomerCardValueTaskCustomerCardValue = 0;
        let automaticCustomerCardValueTaskCardValueChangeType = '';

        if ($('div#' + formWrapperId + ' input[name="special_vat_checkbox"]').is(':checked')) {
            specialVatActivated = 1;
        }

        if ($('div#' + formWrapperId + ' input[name="automatic_customer_card_value_task_active_checkbox"]').is(':checked')) {
            automaticCustomerCardValueTaskActive = 1;
            editCustomerCardValuesTaskId = $('div#' + formWrapperId + ' input[name="edit_customer_card_values_task_id"]').val();
            automaticCustomerCardValueTaskFrequency = $('div#' + formWrapperId + ' select[name="automatic_customer_card_value_task_frequency"]').val();
            automaticCustomerCardValueTaskDayOfMonth = $('div#' + formWrapperId + ' select[name="automatic_customer_card_value_task_day_of_month"]').val();
            automaticCustomerCardValueTaskDayOfWeek = $('div#' + formWrapperId + ' select[name="automatic_customer_card_value_task_day_of_week"]').val();
            automaticCustomerCardValueTaskCronTime = $('div#' + formWrapperId + ' select[name="automatic_customer_card_value_task_cron_time"]').val();
            automaticCustomerCardValueTaskCustomerCardValue = $('div#' + formWrapperId + ' input[name="automatic_customer_card_value_task_customer_card_value"]').val();
            automaticCustomerCardValueTaskCardValueChangeType = $('div#' + formWrapperId + ' select[name="automatic_customer_card_value_task_card_value_change_type"]').val();
        }

        if ($('div#' + formWrapper + ' input[name="customer_group_id"]').length) {
            customerGroupId = $('div#' + formWrapper + ' input[name="customer_group_id"]').val();
        }

        //Check that a valid group number is given
        if (isNaN(groupNumber)) {
            //valid number
            displayErrorMessage('Gruppenummer må være numerisk');
            return;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'POST',
            url: ajaxPath,
            data: {
                name: name,
                group_number: groupNumber,
                special_vat_code: specialVatCode,
                special_vat_activated: specialVatActivated,
                customer_group_id: customerGroupId,
                automatic_customer_card_value_task_active: automaticCustomerCardValueTaskActive,
                edit_customer_card_values_task_id: editCustomerCardValuesTaskId,
                automatic_customer_card_value_task_frequency: automaticCustomerCardValueTaskFrequency,
                automatic_customer_card_value_task_day_of_month: automaticCustomerCardValueTaskDayOfMonth,
                automatic_customer_card_value_task_day_of_week: automaticCustomerCardValueTaskDayOfWeek,
                automatic_customer_card_value_task_cron_time: automaticCustomerCardValueTaskCronTime,
                automatic_customer_card_value_task_customer_card_value: automaticCustomerCardValueTaskCustomerCardValue,
                automatic_customer_card_value_task_card_value_change_type: automaticCustomerCardValueTaskCardValueChangeType
            },
            dataType: 'json'
        }).success(function (data) {
            displaySuccessMessage('Kundegruppe lagret, trykk <a href="' + window.location.href + '">her</a> for å lagre ny kundegruppe');
            refreshListItems();
        }).error(function (data) {
            var errors = $.parseJSON(data.responseText).errors;
            displayErrorMessage(errors);
        }).always(function() {
            ajaxLockActive = false;
        });
        return false;
    });

    /*
	 * Change status of a CustomerGroup
	 * Status = 1: active
	 * Status = 0: deactivated
	 */
    $(document).on('click', 'div#' + formWrapperId + ' a.change_status', function () {
        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        var currentStatus = $(this).attr('current_status');

        // User must confirm deactivation
        if (currentStatus === '1') {
            if (!confirm('Vil du deaktivere kundegruppe?')) {
                return;
            }
        }

        var customerGroupId = $('div#' + formWrapperId + ' input[name="customer_group_id"]').val();
        if (isNaN(customerGroupId)) {
            displayErrorMessage('Fant ikke kundegruppe som skal endre status');
        }

        var status = (currentStatus === '1')?0:1;

        ajaxLockActive = true;
        $.ajax({
            type: 'POST',
            url: ajaxPath,
            data: {
                status: status,
                customer_group_id: customerGroupId
            },
            dataType: 'json'
        }).success(function (data) {
            formWrapper.html('<div class="alert alert-success">Kundegruppe lagret, trykk <a href="' + window.location.href + '">her</a> for å lagre ny kundegruppe</div>');
            refreshListItems();
        }).error(function (data) {
            var errors = $.parseJSON(data.responseText).errors;
            displayErrorMessage(errors);
        }).always(function() {
            ajaxLockActive = false;
        });
        return false;
    });

    /*
	 * Display or hide filter options
	 */
    $(document).on('click', 'div#' + listWrapperId + ' span#filter_span_wrapper', function () {
        // Toggle the filters wrapper
        $('div#filter_options_wrapper').toggle();

        // Change class of the glyphicon (arrow right or down
        var arrow = $('span#filter_span_wrapper span.glyphicon');
        if ($(arrow).hasClass('glyphicon-chevron-right')) {
            // Switch to down arrow
            $(arrow).removeClass('glyphicon-chevron-right');
            $(arrow).addClass('glyphicon-chevron-down');
        } else {
            // Switch to down right
            $(arrow).removeClass('glyphicon-chevron-down');
            $(arrow).addClass('glyphicon-chevron-right');
        }
    });

    // Refresh list if deactivated checkbox in filters is clicked
    $(document).on('click', 'div#' + listWrapperId + ' input[name="display_deactivated"]', function () {
        refreshListItems();
    });

    /*
	 * Search if search button was clicked
	 */
    $('div#' + listWrapperId + ' button#customer_group_search_button').click(function(){
        refreshListItems();
    });

    /*
	 * Search if enter key in the search field
	 */
    $('div#' + listWrapperId + ' input#customer_group_search_input').keyup(function(e) {
        var key = e.which;
        var searchInput = $('input#customer_group_search_input');

        // Refresh list if enter was pressed or the search field is empty
        if (key === 13 || searchInput.val() === '') {
            refreshListItems();
        }
    });

    function refreshForm(customerGroupId) {
        var ajaxPath = ajaxPathForm;
        if (!isNaN(customerGroupId) && customerGroupId > 0) {
            ajaxPath = ajaxPathForm + '/' + customerGroupId
        }
        $.ajax({
            type: 'GET',
            url: ajaxPath,
            data: {
            },
            dataType: 'json'
        }).success(function (data) {
            formWrapper.html(data.html);
        }).error(function (data) {
            formWrapper.append('<div class="alert alert-danger">' + data.errors + '</div>');
        });
        return false;
    }

    function refreshListItems(searchString) {
        var displayDeactivated = 0;
        if ($('input[name="display_deactivated"]', listWrapper).is(':checked')) {
            displayDeactivated = 1;
        }

        var searchString = $('div#' + listWrapperId + ' input#customer_group_search_input').val();

        $.ajax({
            type: 'GET',
            url: ajaxPathListItems,
            data: {
                include_deactivated_groups: displayDeactivated,
                search_string: searchString
            },
            dataType: 'json'
        }).success(function (data) {
            $('div.list-group', listWrapper).replaceWith(data.html);
        }).error(function (data) {
            var errors = $.parseJSON(data.responseText).errors;
            displayErrorMessage(errors);
        });
        return false;
    }

    function displayErrorMessage(message) {
        $('div#' + alertWrapperId, formWrapper).html('<div class="alert alert-danger">' + message + '</div>');
    }

    function displaySuccessMessage(message) {
        $('div#' + alertWrapperId, formWrapper).html('<div class="alert alert-success">' + message + '</div>');
    }

    //export chosen data and format
    $(document).on('click', "input[name='saveCustomerGroup']", function() {
        var name = $("input[name='name']").val();
        var groupNumber = $("input[name='group_number']").val();
        var customerGroupId = $("input[name='customerGroupId']").val();
        var specialVat = $("select[name='special_vat']").val();
        var validGroupNumber = false;
        var validVat = false;
        //Check that a valid group number is given
        if (!isNaN(validGroupNumber)) {
            //valid number
            validGroupNumber = true;
        }

        //check if valid vat
        if ((!isNaN(specialVat) && specialVat * 1 >= 0) || specialVat == "") {
            validVat = true;
        }

        if (validGroupNumber && validVat) {
            $.post("/includes/kunde/ajax.php", {saveCustomerGroup: "1", name: name, groupNumber: groupNumber, customerGroupId: customerGroupId, specialVat: specialVat},
                function(data) {
                    $('#adminmeny_midten_hoyre').prepend(data);
                    $('#lagreBeskjed').fadeIn();
                    setTimeout(function() {
                        $('#lagreBeskjed').fadeOut('slow');
                    }, 5000);

                    //success save, refresh form
                    if (data.indexOf("messagebox") >= 0) {
                        //save ok, reload group list
                        $.post("/includes/kunde/ajax.php", {fetchCustomerGoupList: "1"},
                            function(data) {
                                $("#adminmeny_hoyre").html($(data).find("#span_hoyre").html());
                            });

                        $("input[name='name']").val("");
                        $("input[name='group_number']").val("");
                        $("input[name='customerGroupId']").val("");
                        $("input[name='special_vat']").val("");
                        $("legend", "form[name='newCustomerGroupClass']").html("Ny kundegruppe");
                    }
                });
        } else if (!validGroupNumber) {
            alert("Ikke gyldig gruppenummer, må være numerisk");
        } else if (!validVat) {
            alert("Fast MVA må enten stå tom eller være numerisk");
        }
    });
});